<template>
  <div>
    <b-button
      :id="uid"
      :variant="project_powered_variant"
      :pressed="project_powered"
      :disabled="disabled"
      size="sm"
      @click.stop="toggle_project_powered"
    >
      <span :class="project_powered_icon" />
    </b-button>
    <b-tooltip :target="uid" placement="bottomright" :show.sync="tooltipshown">
      <p>{{ $t('pause_resume_project') }}</p>
      <p>
        <b-button variant="primary" :pressed="false" size="sm">
          <span class="fas fa-sync-alt fa-fw synaplus-cosmo-spinpause" />
        </b-button>
        {{ $t('computing_project') }}
      </p>
      <p>
        <b-button variant="success" :pressed="false" size="sm">
          <span class="fas fa-pause fa-fw" />
        </b-button>
        {{ $t('activated_idle_project') }}
      </p>
      <p>
        <b-button variant="outline-danger" :pressed="false" size="sm">
          <span class="fas fa-play fa-fw" />
        </b-button>
        {{ $t('paused_project') }}
      </p>
    </b-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'
import * as moment from 'moment'
import 'moment/locale/fr'

import { mapGetters, mapState } from 'vuex'

import { subscription_mixin } from '@/components/mixin.js'
import { set_project_power } from '@/api/subscriptions.js'

// *****************************************************************************

export default {
  name: 'ProjectPoweredButton',

  props: ['value', 'disabled'],
  data() {
    return {
      uid: _.uniqueId(),
      tooltipshown: false,
    }
  },
  computed: {
    project_id() {
      return (this.value || {}).project_id
    },
    project_powered_icon() {
      return this.project_powered
        ? this.project_running
          ? 'fas fa-sync-alt fa-fw synaplus-cosmo-spinpause'
          : 'fas fa-pause fa-fw'
        : 'fas fa-play fa-fw'
    },
    project_powered_variant() {
      return this.project_powered
        ? this.project_running
          ? 'primary'
          : 'success'
        : 'outline-danger'
    },
    project_powered() {
      let res = !(_.isEmpty(this.value) || this.value.is_paused)
      return res
    },
    project_running() {
      let res =
        !_.isUndefined(this.project_id) &&
        this.project_id === this.platform_status.current_running_project_id
      return res
    },
    project_powered_pressed() {
      return this.project_powered
    },
    ...mapState(['platform_status']),
  },

  methods: {
    toggle_project_powered() {
      this.tooltipshown = false
      set_project_power(this.project_id, !this.project_powered)
    },
  },
}
</script>
